<template>
  <div class="addProductsComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else class="col-md-12">
      <v-form ref="form" lazy-validation class="mt-5 col-sm-12 col-md-12">
        <div class="custom-row">
          <div class="col-sm-12 col-md-4">

            <div v-if="this.roleId !== '1'">
              <v-select :label="'*'+$t('product.label.mode.title')" :placeholder="$t('product.label.mode.text')" required
                color="secondary" :items=modos item-text="nombre" item-value="idModoCategoria" v-model="formData.idModo"
                @change="actualizarCategorias" :disabled="formData.idModo === 2" :rules="modoRules"></v-select>
            </div>

            <div v-if="this.roleId === '1'">
              <v-select :label="'*'+$t('product.label.mode.title')" :placeholder="$t('product.label.mode.text')" required
                color="secondary" :items=modos item-text="nombre" item-value="idModoCategoria" v-model="formData.idModo"
                @change="actualizarCategorias" :rules="modoRules"></v-select>
            </div>

            <v-select :disabled=!formData.idModo :label="'*'+$t('product.label.category.title')" :placeholder="$t('product.label.category.text')" 
              :items="categoriasFiltradas" item-value="idCategoriaComercial" item-text="nombre" color="secondary" required @change="actualizarSubCategorias"
              :value.sync="formData.idCategoriaComercial" v-model="formData.idCategoriaComercial" :rules="categoriaRules"></v-select>

            <v-select :disabled=!formData.idCategoriaComercial :label="'*'+$t('product.label.subCategory.title')" :placeholder="$t('product.label.subCategory.text')"
              :items="subCategoriasFiltradas" item-text="nombreTipoProducto" item-value="idTipoProducto" color=secondary required
              v-model="formData.idSubCategoria" :rules="subCategoriaRules"></v-select>

            <v-select v-if="formData.idModo === 1" :disabled=!formData.idSubCategoria color=secondary
              :label="'*'+$t('product.label.supplier.title')" :placeholder="$t('product.label.supplier.text')"
              required :items="proveedores" item-text="nameSupplier" item-value="supplierId" v-model="formData.supplierId" :rules="proveedorRules"></v-select>

            <v-text-field :label="'*'+$t('product.label.nameProduct.title')" :placeholder="$t('product.label.nameProduct.text')" 
              color=secondary required v-model="formData.nombre" :rules="nombreRules" :counter="40" :maxlength="40"></v-text-field>

            <v-text-field :label="'*'+$t('product.label.codProduct.title')" :placeholder="$t('product.label.codProduct.text')"
              color=secondary required v-model="formData.codProducto" :rules="codigoProductoRules" :counter="6" :maxlength="6"></v-text-field>

            <v-text-field :label="'*'+$t('product.label.description.title')" :placeholder="$t('product.label.description.text')" 
              color=secondary required v-model="formData.descripcion" :rules="descripcionRules" :counter="50" :maxlength="50"></v-text-field>

          </div>

          <div class="col-sm-12 col-md-4">

            <v-text-field v-if="formData.idModo === 1" :disabled="!formData.idModo" color="secondary" 
              :label="'*'+$t('product.label.price.title')" :placeholder="$t('product.label.price.text')"
              required v-model="formattedPrecio" @keydown="handleKeyDown" @blur="handleBlur" type="text" :rules="valorUnitarioClienteRules" clearable></v-text-field>

            <input type="file" class="btn-cargue" @change="handleFileChange" ref="fileInput" style="display: none;"
              accept=".pdf" />
            <v-text-field readonly color=secondary :label="'*'+$t('product.label.file.title')" required
              v-model="formData.archivoDetalleNombre" :rules="archivoDetalleRules" @click="triggerFileInput"
              @change="handleFileChange" append-icon="mdi-file-find"></v-text-field>

            <v-text-field v-if="formData.idModo === 1" :disabled="!formData.idModo" :label="$t('product.label.linkYoutube.title')"
              color=secondary :placeholder="placeholderEnlaceInformacionYoutube" v-model="formData.linkYoutube" :counter="200" :maxlength="200">
            </v-text-field>

            <v-text-field :label="'*'+$t('product.label.feature1.title')" color=secondary required v-model="formData.caracteristica1"
              :rules="caracteristicaRules" :counter="40" :maxlength="40"></v-text-field>

            <v-text-field :label="$t('product.label.feature2.title')" color=secondary required v-model="formData.caracteristica2"
              :counter="40" :maxlength="40"></v-text-field>

            <v-text-field :label="$t('product.label.feature3.title')" color=secondary required v-model="formData.caracteristica3"
              :counter="40" :maxlength="40"></v-text-field>

            <v-text-field :label="$t('product.label.website.title')" :placeholder="placeholderEnlaceInformacion" color=secondary
              v-model="formData.enlaceInformacion" :counter="200" :maxlength="200"></v-text-field>

            <v-row>
              <v-col cols="4" md="3" sm="3">
                <v-select :label="'*'+$t('label.indicative.title')" color="secondary" required :items="listGender"
                  item-text="countryPhoneCode" item-value="countryPhoneCodeId" v-model="formData.countryPhoneCodeId" :rules="CountryPhoneCodeRules">
                </v-select>
              </v-col>
              <v-col cols="8" md="9" sm="9">
                <v-text-field :label="'*'+$t('label.phone.title')" :placeholder="$t('label.phone.text')" 
                  color="secondary" required :rules="phoneRules" v-model="formData.contacto"
                  @keydown="handleKeyDown" inputmode="numeric" pattern="[0-9]{0,15}" :counter="15" :maxlength="15">
                </v-text-field>
              </v-col>
            </v-row>
          </div>

        </div>
      </v-form>


    </div>
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on" @click="submitForm"><v-icon
            dark>mdi-content-save</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('button.save') }}</span>
    </v-tooltip>
  </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  PRODUCTS_M,
  ACTION_POST_CREATE_PRODUCTS,
  GET_LIST_COUNTRY,
  ACTION_GET_LIST_COUNTRY,
  GET_STATE_LOADING,
} from "@/views/products/store/types/types.js";

import {
  BOARD_M,
  GET_CATEGORIES,
  ACTION_GET_CATEGORIES,
  GET_SUBCATEGORIES,
  ACTION_GET_SUBCATEGORIES,
  GET_MODO,
  ACTION_GET_MODE,
} from "@/views/categories_board/store/types/types.js";

import {
  MARKETPLACE_M,
  GET_CATEGORIES_MARKETPLACE,
  ACTION_GET_CATEGORIES_MARKETPLACE,
  GET_SUBCATEGORIES_MARKETPLACE,
  ACTION_GET_SUBCATEGORIES_MARKETPLACE
} from "@/views/categories_marketplace/store/types/types.js";

import {
  SUPPLIERS_M,
  GET_SUPPLIERS,
  ACTION_GET_SUPPLIERS,
} from "@/views/suppliers/store/types/types.js"
export default {
  name: "addProductsComponent",
  components: {

  },

  data() {
    return {
      formData: {
        idModo: null,
        idCategoriaComercial: null,
        idSubCategoria: null,
        supplierId: null,
        nombre: null,
        codProducto: null,
        descripcion: null,
        archivoDetalle: null,
        linkYoutube: null,
        valorUnitarioCliente: 0,
        archivoDetalleNombre: null,
        caracteristica1: null,
        caracteristica2: null,
        caracteristica3: null,
        enlaceInformacion: null,
        contacto: '',
        countryPhoneCodeId: 1
      },
      categoriasFiltradas: [],
      subCategoriasFiltradas: [],
      roleId: sessionStorage.getItem("roleId"),
      entersContados: 0,
      modoRules: [
        v => !!v || this.$t('product.label.mode.required')
      ],
      categoriaRules: [
        v => !!v || this.$t('product.label.category.required')
      ],
      subCategoriaRules: [
        v => !!v || this.$t('product.label.subCategory.required')
      ],
      proveedorRules: [
        v => !!v || this.$t('product.label.supplier.required')
      ],
      nombreRules: [
        v => !!v || this.$t('product.label.nameProduct.required')
      ],
      codigoProductoRules: [
        v => !!v || this.$t('product.label.codProduct.required')
      ],
      descripcionRules: [
        v => !!v || this.$t('product.label.description.required')
      ],
      valorUnitarioClienteRules: [
        v => !!v || this.$t('product.label.price.required')
      ],
      archivoDetalleRules: [
        v => !!v || this.$t('product.label.file.required')
      ],
      caracteristicaRules: [
        v => !!v || this.$t('product.label.feature1.required')
      ],
      CountryPhoneCodeRules: [
        v => !!v || this.$t('label.indicative.required')
      ],
      phoneRules: [
        v => !!v || this.$t('label.phone.required'),
        v => (v && v.length >= 7 && v.length <= 15) || this.$t('label.phone.maxLength')
      ],
      showErrorMessages: false,
      formattedPrecio: '',
    };
  },

  async mounted() {
    await this.getActionProveedores();
    await this.getActionModos();
    await this.isSuperAdmin();
    this.getActionListCountry();
    // Escuchar evento para limpiar el formulario cuando el diálogo se cierra
    EventBus.$on('clear-products-form', this.clearForm);
  },
  
  beforeDestroy() {
    // Limpiar el event listener
    EventBus.$off('clear-products-form', this.clearForm);
  },
  computed: {
    ...mapGetters({
      loading: [`${PRODUCTS_M}${GET_STATE_LOADING}`],
      categoriaPizarra: [`${BOARD_M}${GET_CATEGORIES}`],
      categoriaMarketplace: [`${MARKETPLACE_M}${GET_CATEGORIES_MARKETPLACE}`],
      subCategoriaPizarra: [`${BOARD_M}${GET_SUBCATEGORIES}`],
      subCategoriaMarketplace: [`${MARKETPLACE_M}${GET_SUBCATEGORIES_MARKETPLACE}`],
      proveedores: [`${SUPPLIERS_M}${GET_SUPPLIERS}`],
      modos: [`${BOARD_M}${GET_MODO}`],
      listGender: [`${PRODUCTS_M}${GET_LIST_COUNTRY}`],

    }),

    placeholderEnlaceInformacion() {
      // observar el valor de formData.idModo
      if (this.formData.idModo === 2) {
        return "https://dominio.com";
      } else if (this.formData.idModo === 1) {
        return "https://www.dominio.com";
      } else {
        return "";
      }
    },
    placeholderEnlaceInformacionYoutube() {
      // Mirar el valor de formData.idModo
      if (this.formData.idModo === 2) {
        return "https://www.youtube.com/watch?v=";
      } else if (this.formData.idModo === 1) {
        return "https://www.youtube.com/watch?v=";
      } else {
        return "";
      }
    },

  },

  methods: {
    ...mapActions({
      getActionModos: `${BOARD_M}${ACTION_GET_MODE}`,
      getActionCategoriaPizarra: `${BOARD_M}${ACTION_GET_CATEGORIES}`,
      getActionSubCategoriaPizarra: `${BOARD_M}${ACTION_GET_SUBCATEGORIES}`,
      getActionCategoriaMarketplace: `${MARKETPLACE_M}${ACTION_GET_CATEGORIES_MARKETPLACE}`,
      getActionSubCategoriaMarketplace: `${MARKETPLACE_M}${ACTION_GET_SUBCATEGORIES_MARKETPLACE}`,
      getActionProveedores: `${SUPPLIERS_M}${ACTION_GET_SUPPLIERS}`,
      postActionCrearProducto: `${PRODUCTS_M}${ACTION_POST_CREATE_PRODUCTS}`,
      getActionListCountry: `${PRODUCTS_M}${ACTION_GET_LIST_COUNTRY}`,

    }),
    async isSuperAdmin() {
      if (this.roleId !== "1") {
        this.formData.idModo = 2;
        this.categoriasFiltradas = await this.getActionCategoriaPizarra(2);
      }
    },

    handleKeyDown(event) {
      // Permite solo números, la tecla de borrar y el punto para decimales
      if (!/^\d$/.test(event.key) && event.key !== 'Backspace' && event.key !== '.') {
        event.preventDefault();
      }
    },

    handleBlur() {
      // Convierte el valor a número con dos decimales cuando el campo pierde el foco
      if (this.formattedPrecio) {
        const numberValue = parseFloat(this.formattedPrecio.replace(/,/g, '')); // Elimina todas las comas
        if (!isNaN(numberValue)) {
          this.formattedPrecio = this.formatNumber(numberValue); // Formatea el número sin comas
          this.formData.valorUnitarioCliente = numberValue;  // Asigna el valor numérico al modelo
        } else {
          this.formattedPrecio = '';
          this.formData.valorUnitarioCliente = null;
        }
      }
    },

    formatNumber(value) {
      // Formatear el número con dos decimales sin comas de separación de miles
      return parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    async submitForm() {
      try {
        // Validar el formulario antes de enviarlo
        const validationErrors = this.validateForm();
        // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
        if (Object.keys(validationErrors).length > 0) {
          const errorMessages = Object.values(validationErrors).join('<br>');
          Swal.fire({
            icon: 'error',
            title: i18n.t('label.errorsValidation.plural.title'),
            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
            confirmButtonColor: '#6E17A5'
          });

          return;
        }

        if (this.formData.idModo === 2) {
          this.formData.supplierId = sessionStorage.getItem("idEmpresa")
        }

        if (!this.formData.linkYoutube || !this.formData.linkYoutube.trim()) {
          this.formData.linkYoutube = '';
        }
        const save = await this.postActionCrearProducto(this.formData);
        if (!save) {
          return Swal.fire({
            icon: 'error',
            title: i18n.t('label.invalid.title'),
            text: i18n.t('label.invalid.text')
          })
        }
        await this.clearForm();
        this.formData.valorUnitarioCliente = null;
        this.formattedPrecio = '';
        EventBus.$emit('form-submit-products');

      } catch (error) {
        console.error(i18n.t('label.failService'));
      }
    },

    validateForm() {

      const youtubePattern = /^https?:\/\/(www\.)?youtube\.com/;
      this.showErrorMessages = true;
      const errors = {};

      // Validación de otros campos
      if (!this.formData.idModo) {
        errors.idModo = this.$t('product.label.mode.title');
      }

      if (!this.formData.idCategoriaComercial) {
        errors.idCategoriaComercial = this.$t('product.label.category.title');
      }

      if (!this.formData.idSubCategoria) {
        errors.idSubCategoria = this.$t('product.label.subCategory.title');
      }

      if (!this.formData.supplierId && this.formData.idModo === 1) {
        errors.supplierId = this.$t('product.label.supplier.title');
      }

      if (!this.formData.nombre || !this.formData.nombre.trim()) {
        errors.nombre = this.$t('product.label.nameProduct.title');
      }

      if (!this.formData.codProducto || !this.formData.codProducto.trim()) {
        errors.codProducto = this.$t('product.label.codProduct.title');
      }

      if (!this.formData.descripcion || !this.formData.descripcion.trim()) {
        errors.descripcion = this.$t('product.label.description.title');
      }

      if (!this.formattedPrecio) {
        if (this.formData.idModo === 1) {
          errors.valorUnitarioCliente = this.$t('product.label.price.title');
        }
      }

      if (!this.formData.archivoDetalle) {
        errors.archivoDetalle = this.$t('product.label.file.title');
      }

      if (!this.formData.caracteristica1 || !this.formData.caracteristica1.trim()) {
        errors.caracteristica1 = this.$t('product.label.feature1.title');
      }

      if (this.formData.caracteristica2 && !/\S/.test(this.formData.caracteristica2)) {
        errors.caracteristica2 = this.$t('product.label.feature.errorBlankSpaces');
      }

      if (this.formData.caracteristica3 && !/\S/.test(this.formData.caracteristica3)) {
        errors.caracteristica3 = this.$t('product.label.feature.errorBlankSpaces');
      }

      if (!this.formData.contacto || !/^[0-9]{7,15}$/.test(this.formData.contacto)) {
        errors.contacto = this.$t('label.phone.title');
      }

      if (this.formData.linkYoutube && !youtubePattern.test(this.formData.linkYoutube)) {
        errors.linkYoutube = this.$t('product.label.linkYoutube.title');
      }
      return errors;
    },

    contarEnters() {
      // Contar los enters en el valor actual del textarea
      const enters = this.formData.contacto.split("\n").length - 1;

      // Limitar a 3 enters
      if (enters > 2) {
        this.formData.contacto = this.formData.contacto.replace(/\n/g, ',');
      } else {
        this.entersContados = enters;
      }
    },

    async actualizarCategorias() {
      if (this.formData.idModo === 1) {
        // Si es Marketplace, obtén las categorías de Marketplace
        this.categoriasFiltradas = await this.getActionCategoriaMarketplace(1);
      } else if (this.formData.idModo === 2) {
        // Si es Pizarra, obtén las categorías de Pizarra
        this.categoriasFiltradas = await this.getActionCategoriaPizarra(2);
      } else {
        // En caso contrario, limpia la lista de categorías
        this.categoriasFiltradas = [];
      }
    },

    async actualizarSubCategorias() {
      if (this.formData.idCategoriaComercial) {
        if (this.formData.idModo === 1) {
          // Si es Pizarra, obtén las subcategorías de Pizarra
          const subCategoriasFiltradasP = await this.getActionSubCategoriaPizarra(this.formData.idCategoriaComercial);
          this.subCategoriasFiltradas = subCategoriasFiltradasP.tipoProductos;
          this.formData.idSubCategoria = null;
        } else if (this.formData.idModo === 2) {
          // Si es Marketplace, obtén las subcategorías de Marketplace
          const subCategoriasFiltradasM = await this.getActionSubCategoriaMarketplace(this.formData.idCategoriaComercial);
          this.subCategoriasFiltradas = subCategoriasFiltradasM.tipoProductos;
          this.formData.idSubCategoria = null;
        }
      } else {
        // En caso contrario, limpia la lista de subcategorías
        this.subCategoriasFiltradas = [];
      }

    },

    handleFileChange(event) {
      const file = event.target.files[0];

      // Verifica si el arhivo es un PDF
      if (file.type === 'application/pdf') {
        // Verifica el tamaño del archivo (en bytes)
        const fileSizeMB = file.size / (1024 * 1024); // Convertir a megabytes
        const maxFileSizeMB = 30; // Tamaño máximo permitido en megabytes

        if (fileSizeMB > maxFileSizeMB) {
          // Muestra un mensaje de error si el archivo excede el tamaño máximo permitido
          Swal.fire({
            icon: 'error',
            title: i18n.t('label.errorsValidation.singular.title'),
            text: i18n.t('label.errorSizeFile')
          });

          // Reinicia el campo de archivo
          this.formData.archivoDetalleNombre = '';
          this.formData.archivoDetalle = null;
        } else {
          // Asigna el nombre y el archivo al modelo si cumple con los requisitos
          this.formData.archivoDetalleNombre = file.name;
          this.formData.archivoDetalle = file;
        }
      } else {
        // Muestra un mensaje de error si el archivo no es un PDF
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorFormatFile')
        });

        // Reinicia el campo de archivo
        this.formData.archivoDetalleNombre = '';
        this.formData.archivoDetalle = null;
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    clearForm() {
      // Resetear formData
      this.formData = {
        idModo: null,
        idCategoriaComercial: null,
        idSubCategoria: null,
        supplierId: null,
        nombre: null,
        codProducto: null,
        descripcion: null,
        archivoDetalle: null,
        linkYoutube: null,
        valorUnitarioCliente: 0,
        archivoDetalleNombre: null,
        caracteristica1: null,
        caracteristica2: null,
        caracteristica3: null,
        enlaceInformacion: null,
        contacto: '',
        countryPhoneCodeId: 1
      };
      
      // Resetear variables locales
      this.categoriasFiltradas = [];
      this.subCategoriasFiltradas = [];
      this.formattedPrecio = '';
      
      // Resetear validación del formulario
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      
      // Resetear input de archivo
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
  },

};
</script>

<style lang="css" scoped>
.addProductsComponent {
  display: flex;
  gap: 40px;
  flex-direction: row;
  justify-content: center;
}

.custom-row {
  display: flex;
  gap: 40px;
  flex-direction: row;
  justify-content: center;
}

.v-textarea-custom {
  max-height: 3em;
  /* Establece la altura máxima en 3 líneas */
  resize: none;
  /* Evita que el usuario pueda redimensionar el textarea */
}

/*Resposive*/

@media screen and (max-width: 960px) {
  .row-uno {
    flex-direction: column-reverse;
  }
}

@media screen and (max-width: 912px) {
  .col-md-12 {
    gap: 40px;
  }
}

@media screen and (max-width: 820px) {
  .col-md-12 {
    gap: 40px;
  }

  .custom-row {
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: center;
  }
}

@media screen and (max-width: 768px) {
  .col-md-12 {
    gap: 40px;
  }

  .custom-row {
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: center;
  }
}

@media screen and (max-width: 425px) {
  .col-md-12 {
    gap: 10px;
    display: flex;
    flex-direction: column-reverse;
  }

  .custom-row {
    display: flex;
    gap: 50px;
    flex-direction: column;
    justify-content: center;
  }
}
</style>